import { useContext, useEffect, useState } from 'react';
import './SimpleSubscription.css';

import { UserContext } from '../../../../../assets/contexts/userContext';
import mainApi from '../../../../../assets/api/MainApi';
import SimpleSubsctiptionCard from '../../WIX/SimpleSubscription/SimpleSubsctiptionCard/SimpleSubsctiptionCard';

function SimpleSubscriptionMarketplace() {
    const { user } = useContext(UserContext)
    const { default_shop } = user
    const current_subscription = default_shop?.subscriptions?.main

    const [subscriptions, setSubscriptions] = useState(null)

    useEffect(() => {
        mainApi.getSubscrtiptionsWithAuth({ type: 'simple', shop_id: default_shop._id })
            .then((res) => {
                console.log(res)
                setSubscriptions(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }, [default_shop._id])

    console.log(current_subscription)

    return (
        <div className="simple-subscription-marketplace">
            <div className='simple-subscription-marketplace__titles-box'>
                <div className='simple-subscription-marketplace__title-with-logo'>
                    <div className='simple-subscription-marketplace__logo' aria-hidden="true">
                        <span className='simple-subscription-marketplace__logo-cell simple-subscription-marketplace__logo-cell_primary'></span>
                        <span className='simple-subscription-marketplace__logo-cell'></span>
                        <span className='simple-subscription-marketplace__logo-cell'></span>
                        <span className='simple-subscription-marketplace__logo-cell simple-subscription-marketplace__logo-cell_primary'></span>
                    </div>
                    <p className='simple-subscription-marketplace__title'>
                        Специальная цена для продавцов с <span className='simple-subscription-marketplace__title_accent'>маркетплейсов</span>
                    </p>
                </div>
                <p className='simple-subscription-marketplace__subtitle'>
                    Для продавцов, которые переходят с маркетплейсов в свой интернет-магазин, мы предлагаем эксклюзивную подписку по специальной цене.
                </p>
            </div>
            {subscriptions && subscriptions.length > 0 ? <SimpleSubsctiptionCard subscriptions={subscriptions} current_subscription={current_subscription} /> : null}
        </div>
    );
}

export default SimpleSubscriptionMarketplace;
